import React from "react";
import Konva from "konva";
import { Placement } from "@floating-ui/react";
import styles from "./status-picker.module.css";
import { KonvaPicker } from "./konva-picker";

export type StatusOption = {
  index: number;
  label?: string;
  color?: string;
};

type StatusPickerProps = {
  konvaNode: Konva.Node | null;
  stage: Konva.Stage | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  options: StatusOption[];
  onSelect: (option: StatusOption) => void;
  buttonRef: React.RefObject<Konva.Node>;
  side?: Placement;
};

export function StatusPicker({
  konvaNode,
  stage,
  open,
  onOpenChange,
  options,
  onSelect,
  buttonRef,
  side = "bottom-start",
}: StatusPickerProps) {
  const handleOptionClick = (option: StatusOption) => {
    onSelect(option);
    onOpenChange(false);
  };

  return (
    <KonvaPicker
      konvaNode={konvaNode}
      stage={stage}
      open={open}
      onOpenChange={onOpenChange}
      buttonRef={buttonRef}
      side={side}
      className={styles.picker}
      role="listbox"
    >
      {options.map((option) => (
        <button
          key={option.index}
          className={styles.option}
          style={{ backgroundColor: option.color }}
          onClick={() => handleOptionClick(option)}
          type="button"
        >
          {option.label}
        </button>
      ))}
    </KonvaPicker>
  );
}
